/**
 * StockDiagramPage
 * @module pages/StockDiagramPage
 */

import React from 'react';
import Layout from 'components/ui/Layout';
import SectionHeader from 'components/ui/SectionHeader';
import { Grid, Cell } from 'components/ui/Grid';
import { Header } from './CisionStockDiagramPage.styles';
import Breadcrumbs from 'components/framework/Breadcrumbs';
import Icon from 'components/ui/Icon';
import { useSiteType } from 'context/siteType.context';
import clsx from 'clsx';
const StockDiagramPage = (props) => {
	const { heading, breadcrumbs, inEditMode } = props;
	const siteType = useSiteType();
	return (
		<main id="main-content">
			<Layout>
				{breadcrumbs && <Breadcrumbs links={breadcrumbs} />}
				<Grid padding={false}>
					<Cell className="overflow-y-auto" span={12}>
						<Header>
							<SectionHeader
								heading={heading}
								size={'large'}
								isInEditMode={inEditMode}
							/>
						</Header>
					</Cell>
					<Cell
						className={clsx(
							siteType === 'LindabGroup' && 'lg-target-sharegraph-wrapper',
							'overflow-y-auto'
						)}
						span={12}
					>
						<div id="target-ticker"></div>
						<div id="target-sharegraph-wrapper">
							<div className="text-center my-65">
								<Icon
									icon="loader"
									animate="spin"
									size={7}
									aria-hidden={true}
								/>
							</div>
						</div>
					</Cell>
				</Grid>
			</Layout>
		</main>
	);
};

export default StockDiagramPage;
